export default "__VITE_ASSET__DTGVL3sk__"